import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "lib-flexible/flexible.js";

import "./styles/markdown.css";
import "./styles/index.scss";
createApp(App).use(router).mount("#app");
